import ColorsApi from '../../apis/Colors';

export default {
    namespaced: true,
    state: {
        colors: [],
        color_response: null
    },
    mutations: {
        set_colors (state, data) {
            state.colors = data;
        },
        set_color_response (state, value) {
            state.color_response = value;
        }
    },
    actions: {
        async getColors({commit, dispatch}, filters) {
            commit('set_color_response', null);
            return await ColorsApi.get_all(filters)
                .then( response => {
                    commit('set_colors', response.data)
                })
                .catch( error => {
                    commit('set_color_response', 'error');
                })
        },
        async store({commit, dispatch}, color) {
            commit('set_color_response', null);
            return await ColorsApi.store(color)
                .then( response => {
                    commit('set_color_response', 'success');
                    dispatch('getColors');
                })
                .catch( error => {
                    commit('set_color_response', 'error');
                })
        },
        async update({commit, dispatch}, color) {
            commit('set_color_response', null);
            return await ColorsApi.update(color)
                .then( response => {
                    commit('set_color_response', 'success');
                    dispatch('getColors')
                })
                .catch( error => {
                    commit('set_color_response', 'error');
                })
        },
        async change_status({commit, dispatch}, color) {
            commit('set_color_response', null);
            return await ColorsApi.change_status(color)
                .then( response => {
                    commit('set_color_response', 'success');
                    dispatch('getColors')
                })
                .catch( error => {
                    commit('set_color_response', null);
                })
        },
    }
}